// Environment package exports

// Types
export { envType, type EnvironmentConfig } from './types';

// Constants
export * from './constants';

// Core utilities
export {
	getEnvType,
	getHostname,
	getEnvironmentConfig,
	isProduction,
	isStaging,
	isLocal,
	isDevelopment,
} from './utils';
